export const ModelStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  DONE: "done",
  REJECTED: "rejected",
  DELIVERED: "delivered",
};

export const modelStatusInfo = {
  pending: { label: "En attente", class: "bg-warning" },
  approved: { label: "En cours", class: "bg-info" },
  done: { label: "Terminé", class: "bg-success" },
  rejected: { label: "Rejetée", class: "bg-danger" },
  delivered: { label: "Livrée", class: "bg-dark" },
};


export default { ModelStatus, modelStatusInfo };
